module.exports = __webpack_public_path__ + "images/logo_vertical.d3278a4d99aa272c2fc483084a8642f4.png";